import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@/components/Newsletter/newsletter.container"
    ).then((module) => ({
        default: module.NewsletterContainer
    }))
);
